import { postRequest } from '../../../utils';

const getErrorMessage = (errors: unknown, fallback: string): string => {
  if (Array.isArray(errors)) {
    const first = errors[0] as { message?: string } | undefined;
    if (first?.message) {
      return first.message;
    }
  }

  if (typeof errors === 'string' && errors) {
    return errors;
  }

  return fallback;
};

export type NotificationResolveResponse = {
  success: boolean;
  data?: {
    notificationId: number;
    isResolved: boolean;
  };
  error?: string;
};

export const resolveNotification = async (
  notificationId: number,
): Promise<NotificationResolveResponse> => {
  try {
    const result = await postRequest(`/api/notification/resolveNotification/${notificationId}`, {
      isResolved: true,
    });

    if (result?.errors) {
      return {
        success: false,
        error: getErrorMessage(result.errors, 'Failed to resolve notification'),
      };
    }

    if (!result?.resolved) {
      return {
        success: false,
        error: 'Notification resolution response missing',
      };
    }

    return {
      success: true,
      data: {
        notificationId: result.resolved.notificationId,
        isResolved: result.resolved.isResolved,
      },
    };
  } catch (err) {
    console.error('Notification Resolve Error:', err);
    return {
      success: false,
      error: 'A network error occurred while resolving the notification',
    };
  }
};
